import { useMemo } from "react";
import {
  type FlightSteps,
  NavigationFlow,
  useNavigationFlow,
} from "@b2bportal/core-utilities";

type BreadcrumbStepData = {
  step: string;
  label: string;
  isSelected: boolean;
  onClick: () => void;
};

type UseFlightShopBreadcrumbsResponse = {
  shopSteps: Array<BreadcrumbStepData>;
};

export const useFlightShopBreadcrumbs = ({
  currentStepId,
}: {
  currentStepId: FlightSteps;
}): UseFlightShopBreadcrumbsResponse => {
  const goToStep = NavigationFlow.useGoToStep();

  const {
    flow: { stepOrder, steps },
  } = useNavigationFlow();

  const shopSteps = useMemo(() => {
    return stepOrder.reduce<BreadcrumbStepData[]>((acc, stepId) => {
      const step = steps[stepId];

      const isHidden = step.show === false;

      if (step.breadcrumb != null && !isHidden) {
        acc.push({
          step: stepId,
          label: step.breadcrumb.label,
          onClick: () => goToStep(stepId, false),
          isSelected: stepId === currentStepId,
        });
      }
      return acc;
    }, []);
  }, [currentStepId, goToStep, stepOrder, steps]);

  return { shopSteps };
};
